export const carpayPaymentInputRoute = (orderId = ':order_id') => `/carpay/orders/${orderId}/payment-input`
